import type { BaseApiResponse } from '@/interfaces/service/api.interface';
import { getApiResponsePayload } from '@/utils/api.util';
import axios from '@/libs/api/axios';
import { APP_STORE_BY_USER, MATCH_USER_APP_STORE, STORE_SWITCH_URL } from '@/libs/constants/url';
import { FetchAppStoreByUserResponse, FetchMatchUserAppStoreRequest, FetchStoreSwitchRequest } from '@/libs/type/interfaces/appstore';

type FetchAppStoreByUserApiResponse = Omit<FetchAppStoreByUserResponse, 'channels'> & {
  storeChannelList: FetchAppStoreByUserResponse['channels'];
};

export const getAppStoresByUser = async (): Promise<FetchAppStoreByUserResponse[]> => {
  const response = await axios.get<BaseApiResponse<FetchAppStoreByUserApiResponse[]>>(APP_STORE_BY_USER);
  const appStores = getApiResponsePayload(response.data);
  if (!appStores) throw new Error('No app store information received');

  const chanegedChannelsData = appStores.map((appStore) => {
    return {
      ...appStore,
      channels: appStore.storeChannelList
    };
  });
  return chanegedChannelsData;
};

/**
 * 관심병원(app_user_store) 매칭.
 *
 * ⚠️ 종전에는 `params` 를 받아 놓고 **바디 없이** 호출했다. 서버 핸들러는
 * `@RequestBody SwitchStoreRequestModel`(필수)이라 매번
 * `HttpMessageNotReadableException: Required request body is missing` → 500 이 났고,
 * 그래서 이 API 는 **한 번도 성공한 적이 없다**(2026-08-18~26 운영 14건 중 13건 500).
 * 실패가 조용해서 아무도 몰랐고, 결과적으로 신규 회원에게 관심병원이 생기지 않았다.
 *
 * 서버 계약은 `{ storeId, type }` 이다. 필드명을 바꾸려면 백엔드
 * `SwitchStoreRequestModel` 을 같이 봐야 한다 — 구 계약은 `matchType` 이었고,
 * 이관 때 `type` 으로 바뀌면서 이 프론트만 남겨졌다.
 */
export const patchMatchUserAppStore = async (params: FetchMatchUserAppStoreRequest): Promise<boolean | void> => {
  const response = await axios.patch(MATCH_USER_APP_STORE, params);
  return response.data;
};

export const patchStoreSwitch = async (params: FetchStoreSwitchRequest): Promise<boolean | void> => {
  const response = await axios.patch(STORE_SWITCH_URL, params);
  return response.data;
};
